import { useSelector } from "react-redux";
import { IonCard, IonItem, IonItemDivider, IonLabel, IonText } from "@ionic/react";
import { selectUserMessages } from "../../../store/userShow/selectors/selectMessages";
import { MessageItem } from "../../../components/Message/MessageItem";
export const MessagesList: React.FC = () => {
  const messages = useSelector(selectUserMessages);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Bitácora</IonText>
      </h2>
      <section className="ion-padding-horizontal">
        {Object.entries(messages).length === 0 && (
          <IonCard class="ion-no-margin">
            <IonItem lines="none">
              <IonLabel>
                <IonText color="medium">No se ha encontrado actividad</IonText>
              </IonLabel>
            </IonItem>
          </IonCard>
        )}
        {Object.entries(messages).map(([key, value]: any) => (
          <article key={key}>
            <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

            {value.map((messageItem: any, index: number) => (
              <MessageItem
                message={messageItem}
                routerLink={`/app/rrhh/acuerdos/${messageItem.room}`
                }
                key={index}
              />
            ))}
          </article>
        ))}
      </section>
    </>
  );
};
